module.exports = __webpack_public_path__ + "static/media/icon-sourcing-white.eef77190.svg";